import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { noop } from 'rxjs';

@Injectable()
export class LoadingService {
  public constructor(private spinner: NgxSpinnerService) {}

  public showSpinner(): void {
    this.spinner
      .show(undefined, {
        bdColor: 'rgba(0, 0, 0, 0.6)',
        color: '#fff',
        fullScreen: false,
        size: 'medium',
        type: 'ball-clip-rotate-multiple'
      })
      .then(noop);
  }

  public hideSpinner(): void {
    this.spinner.hide().then(noop);
  }
}
